import * as React from 'react';
import * as Charts from '@sail/charts';
import {ResizableContainer} from '../common/ResizableContainer';

const sales = [
  {
    date: 'Jan',
    sold: 1,
  },
  {
    date: 'Feb',
    sold: 4,
  },
  {
    date: 'Mar',
    sold: 2,
  },
  {
    date: 'Apr',
    sold: 3,
  },
];
export const Domain = ({chart}) => {
  const Chart = Charts[chart];
  return (
    <ResizableContainer minWidth={150} width={500} maxWidth={800}>
      <Chart
        data={sales}
        x="date"
        y={{value: 'sold', label: 'Sold', domain: [0, 10]}}
      />
    </ResizableContainer>
  );
};
